// Module
var code = " <div class=\"disabled-overlay stretch\" *ngIf=\"disabled\"></div> <ng-content></ng-content>";
// Exports
module.exports = code;